import React, { useEffect, useState } from "react";
import { Tooltip, Box, Typography, IconButton, Button } from '@mui/material';
import Card from "../../components/card/Card";
import ActionButton from "../../components/actionButton";
import TableContainer from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { filterName } from "../../utils/Utils";
import { userRole } from "../../utils/lists";
import { getAllUser, updateUser } from "../../store/actions/user";
import PermissionComp, { useHasPermission } from "../../components/permissionComp/permissionComp";
import ModalButton from "../../components/modalButton/modalButton";
import UsersForm from "./usersForm";
import edit from '../../assets/edit.png'
import IsDeleteModal from "../../components/isDelete";
import { deleteRecord } from "../../store/reducers/user-slice";

const UsersProfile = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const navigation = useNavigate()
    const { user } = useSelector(state => state.user)

    const { user: loginUser } = useSelector(state => state.auth)

    const auth = useSelector(state => state.auth)
    const [users, setUsers] = useState([])

    const [open, setOpen] = React.useState(false);

    const tableHeader = ['First Name', 'Last Name', 'User Name', 'Email', 'User Profile']
    const verifyParam = ['firstName', 'lastName', 'userName', 'email', 'Role']

    useEffect(() => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLUSER",
            "data": { "CompanyID": auth.user?.businessId },
            "debug": null,
            "token": null
        }
        dispatch(getAllUser(data)).then(res => {
            setIsLoading(false)
        })
    }, [])

    useEffect(() => {
        let arr = []
        user.forEach((ele) => {
            const obj = { ...ele }
            obj['Role'] = ele?.userProfile_ID ? filterName(userRole, ele?.userProfile_ID) : ''
            arr.push(obj)
        })
        setUsers(arr)

    }, [user])

    const hasPermission = useHasPermission(['Users', 'edit'])

    const deleteUser = (data) => {
        let obj = {
            "FirstName": null,
            "MiddleName": null,
            "LastName": null,
            "UserName": null,
            "Password": null,
            "Email": null,
            "Phone": null,
            "CompanyID": null,
            "UserProfileId": null,
            "Address": null,
            "CountryId": null,
            "LocationID": null,
            "StateId": null,
            "CityId": null,
            'ID': data.id,
            'EditBy': loginUser?.userId,
            ISUPDATE: 0
        }
        let sentObj = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "UPDATEUSER",
            "data": obj,
            "debug": null,
            "token": null
        }

        dispatch(updateUser(sentObj)).then(res => {
            setIsLoading(false)
            dispatch(deleteRecord(obj))
            setOpen(false)
        })
    }

    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Users</Typography>
                <PermissionComp list={['Users', 'create']}>
                    <ModalButton open={open} setOpen={setOpen} tooltip={'create'} type={'Button'}>
                        <UsersForm setOpen={setOpen} />
                    </ModalButton>
                </PermissionComp>
            </Box>
            <Card style={{ flex: 1, overflow: 'auto' }}>
                <TableContainer tableHeader={tableHeader}
                    data={users.filter(val => val.Role !== 'Super Admin')}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    action={(data) => hasPermission ? <TableAction id={data.id} deleteRecord={deleteUser} /> : null} />
            </Card>
        </>
    );
};

export default UsersProfile;


const TableAction = ({ id, deleteRecord }) => {
    const [openEdit, setOpenEdit] = React.useState(false);

    return (
        <>
            <PermissionComp list={['Users', 'edit']}>
                <ModalButton open={openEdit} setOpen={setOpenEdit} tooltip={'Edit User'} img={edit} type={'icon'}>
                    <UsersForm data={id} setOpen={setOpenEdit} />
                </ModalButton>
            </PermissionComp>
            <PermissionComp list={['Users', 'delete']}>
                <IsDeleteModal onPress={() => deleteRecord(id)} />
            </PermissionComp>
        </>
    )
}